var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClockFill4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "#486581",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.207.909c-.899.094-1.642.44-2.25 1.048A3.594 3.594 0 0 0 .935 3.99a4.7 4.7 0 0 0 0 1.02A3.61 3.61 0 0 0 3.99 8.065a4.7 4.7 0 0 0 1.02 0 3.684 3.684 0 0 0 1.822-.824A3.637 3.637 0 0 0 8 5.34c.072-.296.092-.475.092-.84s-.02-.544-.092-.84a3.637 3.637 0 0 0-1.168-1.901A3.7 3.7 0 0 0 5.025.937a6.331 6.331 0 0 0-.818-.028m.398 1.598a.264.264 0 0 1 .088.088c.032.056.032.067.032.977v.92l.611.308c.671.338.669.336.669.471 0 .13-.089.219-.218.219-.062 0-.15-.04-.72-.324a15.607 15.607 0 0 1-.7-.362c-.095-.072-.092-.038-.092-1.144 0-.978.001-1.008.03-1.065a.216.216 0 0 1 .3-.088",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockFill4);
export default __webpack_public_path__ + "static/media/icon-clock-fill4.99a0d520a87230b20523982732e4017b.svg";
export { ForwardRef as ReactComponent };